import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
fetch('./assets/config-env/config.json')
  .then(response => response.json())
  .then(config => {

    // 3. Verificamos a flag dentro do JSON
    if (config.production) {
      enableProdMode();
    }

    // 4. Iniciamos o módulo
    platformBrowserDynamic().bootstrapModule(AppModule)
      .catch(err => console.error(err));
  })
  .catch(err => {
    // Tratamento de erro caso o JSON não carregue (tela branca da morte)
    console.error('Erro crítico: Não foi possível carregar config.json', err);
    document.body.innerHTML = 'Falha ao carregar configurações da aplicação.';
  });